import { EPS } from "../constants";

export const Geo = {
  dsq: (a, b) => (b.x - a.x) ** 2 + (b.y - a.y) ** 2,
  d:   (a, b) => Math.sqrt(Geo.dsq(a, b)),

  area: pts => {
    let s = 0, n = pts.length;
    for (let i = 0; i < n; i++) {
      const j = (i + 1) % n;
      s += pts[i].x * pts[j].y - pts[j].x * pts[i].y;
    }
    return s / 2;
  },

  ang: (iv, ov) => {
    const il = Math.sqrt(iv.x * iv.x + iv.y * iv.y);
    const ol = Math.sqrt(ov.x * ov.x + ov.y * ov.y);
    if (il < EPS || ol < EPS) return Infinity;
    let a = Math.atan2(ov.y / ol, ov.x / ol) - Math.atan2(iv.y / il, iv.x / il);
    if (a <= 0) a += 2 * Math.PI;
    return a;
  },

  sx: (a, b, c, d) => {
    const rx = b.x - a.x, ry = b.y - a.y;
    const sx = d.x - c.x, sy = d.y - c.y;
    const dn = rx * sy - ry * sx;
    if (Math.abs(dn) < EPS) return null;
    const qx = c.x - a.x, qy = c.y - a.y;
    const t = (qx * sy - qy * sx) / dn;
    const u = (qx * ry - qy * rx) / dn;
    if (t < -EPS || t > 1 + EPS || u < -EPS || u > 1 + EPS) return null;
    return { x: a.x + t * rx, y: a.y + t * ry, t: Math.max(0, Math.min(1, t)), u: Math.max(0, Math.min(1, u)) };
  },

  cosABC: (a, b, c) => {
    const abx = b.x - a.x, aby = b.y - a.y;
    const bcx = c.x - b.x, bcy = c.y - b.y;
    const la = Math.sqrt(abx * abx + aby * aby);
    const lb = Math.sqrt(bcx * bcx + bcy * bcy);
    if (la < EPS || lb < EPS) return 0;
    return (abx * bcx + aby * bcy) / (la * lb);
  },

  project: (p, a, b) => {
    const dx = b.x - a.x, dy = b.y - a.y;
    const len2 = dx * dx + dy * dy;
    if (len2 < EPS) return { point: { ...a }, t: 0, dist: Geo.d(p, a) };
    const t = Math.max(0, Math.min(1, ((p.x - a.x) * dx + (p.y - a.y) * dy) / len2));
    const pt = { x: a.x + t * dx, y: a.y + t * dy };
    return { point: pt, t, dist: Geo.d(p, pt) };
  },

  centroid: pts => ({
    x: pts.reduce((s, p) => s + p.x, 0) / pts.length,
    y: pts.reduce((s, p) => s + p.y, 0) / pts.length,
  }),

  aabb: pts => ({
    minX: Math.min(...pts.map(p => p.x)),
    maxX: Math.max(...pts.map(p => p.x)),
    minY: Math.min(...pts.map(p => p.y)),
    maxY: Math.max(...pts.map(p => p.y)),
  }),

  aabbOvlp: (a, b) =>
    a.minX <= b.maxX && a.maxX >= b.minX && a.minY <= b.maxY && a.maxY >= b.minY,
};
